import { render, staticRenderFns } from "./reportedConsumables.vue?vue&type=template&id=35304f0e&scoped=true"
import script from "./reportedConsumables.vue?vue&type=script&lang=js"
export * from "./reportedConsumables.vue?vue&type=script&lang=js"
import style0 from "./reportedConsumables.vue?vue&type=style&index=0&id=35304f0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35304f0e",
  null
  
)

export default component.exports